import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { List as VirtualizedList, AutoSizer } from 'react-virtualized';
import classNames from 'classnames';
import './List.scss';


class List extends PureComponent {
  constructor (props) {
    super(props)
    this._rowRenderer = this._rowRenderer.bind(this)
  } 

  _rowRenderer({ index, isScrolling, key, style }) {
    const { items } = this.props;
    const item = items[index];
    //onMouseEnter={ _ => hilight(item.id) }
    const product = item.products[0];

    const link = product
      ? `/browse/${item.id}/${product.id}/`
      : `/browse/${item.id}/`;

    return (
      <div
        className={classNames('row', 'item', 'align-items-center', {active: false })}
        key={key}
        style={style}
        
      >
        <div className="col-9 col-md-6 d-flex align-items-center">
          <i className={`icon ${item.type}`}/>
          <Link to={link}>
            { item.address }
          </Link>
        </div>
        <div className="col-3 col-md-2 text-right  text-muted">
          { item.code }
        </div>
        <div className="col-md-4 hidden-xs-down text-right text-muted">{ item.district.name }</div>
      </div>
    )
  }

  //onMouseLeave={_ => this.props.hilight(null)
  render () {
    return (
      <div className="col list-container">
      <AutoSizer>
        {size => (
          <VirtualizedList
            id="item-list"
            rowHeight={50}
            rowCount={this.props.items.length}
            rowRenderer={this._rowRenderer}
            items={this.props.items}
            {...size}
          />
        )}
      </AutoSizer>
      </div>
    )
  }
}

export default List;


// WEBPACK FOOTER //
// ./src/scenes/FilterList/List.js